<template>
  <v-row>
    <v-col cols="12" class="pl-0">
      <span class="text-subtitle-2">Informações Veículo</span>
      <v-divider></v-divider>
    </v-col>
    <v-col cols="12" class="mx-auto pl-0">
      <input-radiogroup @change="changeTipoPlaca" v-model="model.TipoPlaca" required row>
        <v-radio v-for="tipoPlaca in $aux.TipoPlaca.filter(item => [1, 2, 3, 6].includes(item.value))"
          :key="tipoPlaca.value" :value="tipoPlaca.value">
          <template v-slot:label>
        <v-tooltip v-if="tipoPlaca.text === 'Outros'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="mr-2">{{ tipoPlaca.text }}</span>
          </template>
          <span>Este campo é destinado a veículos que não constam na Tabela Fipe, como importados,
            customizados, clássicos, edições limitadas e Outros.
          </span>
        </v-tooltip>
        <span v-else class="mr-2">{{ tipoPlaca.text }}</span>
      </template>
        </v-radio>
      </input-radiogroup>
    </v-col>

    <v-col cols="6" class="pl-0">
      <input-autocomplete v-if="!outros" :items="marcas" label="Marca" v-model="model.Marca" @change="changeMarca"
        required />
      <input-text v-else label="Marca" v-model="model.Marca" required />
    </v-col>
    <v-col cols="6" class="pr-0">
      <input-autocomplete v-if="!outros" :items="modelos" ref="modelo" label="Modelo" v-model="model.CodigoFipe"
        @change="changeCodigoFipe" required />
      <input-text v-else label="Modelo" v-model="model.Modelo" required />
    </v-col>

    <input-ano v-if="!outros" class="pl-0" ref="ano" v-model="model"
      :carencia="$param.Veiculos_QtdeAnoLimite ? $param.Veiculos_QtdeAnoLimite : 15" @change="changeFipe" required />
    <template v-else>
      <v-col cols="3">
        <input-select required label="Ano Fabricação" v-model="model.AnoFab" :options="anos">
          <template v-slot:append>
            <v-icon color="accent">ph-caret-down</v-icon>
          </template>
        </input-select>
      </v-col>
      <v-col cols="3">
        <input-select required label="Ano Modelo" append-icon="ph-caret-down" v-model="model.AnoMod"
          :disabled="!model.AnoFab" :options="anosModelo">
        </input-select>
      </v-col>
    </template>
    <v-col cols="3">
      <input-text v-if="!outros" disabled readonly label="Valor Fipe" :value="$api.UI.Format.Decimal(model.VlrFipe)"
        required />
      <input-number v-else format="currency" v-model="model.VlrFipe" label="Valor Veículo" required />
    </v-col>
    <v-col cols="3" class="pr-0">
      <input-select label="UF Licenciamento" :options="$aux.UF" item-value="UF" item-text="Nome"
        v-model="model.UFLicenciamento" @change="$emit('loadVlrRegistro')" required />
    </v-col>
    <v-col cols="4" class="pl-0">
      <input-select label="Tipo Veiculo" v-model="model.TipoVeiculo" :options="$aux.TipoVeiculo"
        :required="!model.ZeroKM" />
    </v-col>
    <v-col cols="4">
      <input-text label="Placa" v-mask="['AAA#X##']" v-model="model.Placa" :required="!model.ZeroKM" upper-case />
    </v-col>
    <v-col cols="4" class="pr-0">
      <input-text label="Renavam" v-model="model.Renavam" v-mask="['###########']" :required="!model.ZeroKM" />
    </v-col>
    <v-col cols="4" class="pl-0">
      <input-text label="Chassi" v-mask="'XXXXXXXXXXXXXXXXX'" v-model="model.Chassi" required upper-case />
    </v-col>
    <v-col cols="4">
      <input-select label="Tipo Chassi" v-model="model.TipoChassi" :options="$aux.TipoChassi"
        :required="!model.ZeroKM" />
    </v-col>
    <v-col cols="4" class="pr-0">
        <input-select label="Tipo Restrição Gravame"
                      :options="$aux.TipoRestricaoGravame"
                      :value="model.TipoRestricaoGravame"
                      disabled />

    </v-col>
    <v-col cols="4" class="pl-0">
      <input-text label="Cor" v-model="model.Cor" :required="!model.ZeroKM" />
    </v-col>
    <v-col cols="4">
        <input-number v-model="model.KM" label="KM Veículo" />
    </v-col>
    <v-col cols="4" v-if="vlrRegistro">
      <input-text label="Valor do Registro" :value="$api.UI.Format.Decimal(vlrRegistro)" readonly disabled />
    </v-col>
    <v-col cols="12" class="pl-0">
      <span class="text-subtitle-2">Informações de Financiamento</span>
      <v-divider></v-divider>
    </v-col>
    <v-col cols="4" class="pl-0">
      <input-number label="Saldo Financiamento" v-model="model.SaldoFinanciamento" :disabled="!model.Financiado"
        format="currency" />
    </v-col>
    <v-col cols="4">
      <strong><v-checkbox v-model="model.Financiado" label="Financiado" @change="limparSaldo"></v-checkbox></strong>
    </v-col>

  </v-row>
</template>
<script>
export default {
  props: {
    vlrRegistro: null,
    chave: null,
    value: null,
  },
  data () {
    return {
      marcas: [],
      modelos: [],
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    outros () {
      return this.model.TipoPlaca === 6
    },
    anos () {
      const AnoFab = [];
      const anoAtual = new Date().getFullYear();

      for (let ano = 1980; ano <= anoAtual; ano++) {
        AnoFab.push({ text: ano.toString(), value: ano });
      }
      return AnoFab
    },
    anosModelo () {
      if (!this.model.AnoFab) return this.anos;

      const anoFab = parseInt(this.model.AnoFab);
      const ultimoAno = parseInt(this.anos[this.anos.length - 1].value);
      const anosFiltrados = this.anos.filter(ano => {
        const anoValue = parseInt(ano.value);
        return anoValue === anoFab || anoValue === anoFab + 1;
      });
      if (anoFab === ultimoAno) {
        anosFiltrados.push({ text: (anoFab + 1).toString(), value: (anoFab + 1) });
      }

      return anosFiltrados;
    }
  },
  methods: {
    changeTipoPlaca (value) {
      const th = this
      th.$set(th.model, 'Marca', null)
      if (!th.outros) {
        th.changeMarca()
      } else {
        th.limparDadosVeiculo()
      }
      if (value && !th.outros) {
        th.carregaMarcas(value)
      }
    },
    carregaMarcas (value) {
      const th = this
      th.marcas = []
      th.$api.Kraken.GetAllMarcas(value).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          th.marcas = response.map(item => item.marcaId)
        }
      })
    },
    changeMarca (value) {
      const th = this
      if (value) {
        th.carregaModelos(value)
      }
    },
    changeCodigoFipe (value) {
      const th = this

      th.$refs.ano.clear()
      th.$set(th.model, 'AnoFab', null)
      th.$set(th.model, 'AnoMod', null)
      th.$set(th.model, 'KM', null)
      th.$set(th.model, 'VlrFipe', null)
      th.$set(th.model, 'Modelo', null)

      if (value) {
        const modelo = th.modelos.find(p => p.value === value)
        th.$set(th.model, 'Modelo', modelo.text)
        th.carregaFipe(modelo.text, true)
      }
    },
    carregaFipe (value, openMenu) {
      const th = this
      th.$refs.ano.loadData(openMenu, value, anoBase => {
        th.$api.UI.Mensagem('alerta', `Não existe modelo com ano superior à ${anoBase} para os valores selecionados`, () => {
          th.model.CodigoFipe = null
          th.$nextTick(th.$refs.modelo.focus())
        })
      })
    },
    carregaModelos (value) {
      const th = this

      th.modelos = []
      th.$api.Kraken.GetAllModeloPorMarca(th.model.TipoPlaca, value).then(function (response) {
        if (th.$api.UI.PostLoadData(response)) {
          th.modelos = response.filter(p => p.modelo).map(p => { return { text: p.modelo, value: p.codigoFipe } })
        }
      })
    },
    changeFipe (value) {
      this.$set(this.model, 'VlrFipe', value)
    },
    limparSaldo () {
      this.$set(this.model, 'SaldoFinanciamento', null)
    },
    limparDadosVeiculo () {
      const th = this
      th.$set(th.model, 'Modelo', null)
      th.$set(th.model, 'AnoFab', null)
      th.$set(th.model, 'AnoMod', null)
      th.$set(th.model, 'KM', null)
      th.$set(th.model, 'VlrFipe', null)
      th.$set(th.model, 'TipoVeiculo', null)
      th.$set(th.model, 'Renavam', null)
      th.$set(th.model, 'Chassi', null)
      th.$set(th.model, 'TipoChassi', null)
    }
  },
  mounted () {
    const th = this
    if (th.model.TipoPlaca && th.model.Marca) {
      if (th.model.TipoPlaca === 6) return
      th.carregaMarcas(th.model.TipoPlaca)
      th.carregaModelos(th.model.Marca, function () {
        const modelo = th.modelos.find(p => p.value === th.model.CodigoFipe)
        if (modelo) {
          th.$set(th.model, 'Modelo', modelo.text)
        }
        th.carregaFipe(th.model.Modelo)
      })
    }
    th.$set(th.model, 'TipoRestricaoGravame', 3)
    th.$set(th.model, 'TipoRestricao', 3)
  }

}
</script>
